import { LLM } from '@/types'
import i18next from 'i18next'

import { NOVA_SONIC_MODEL_ID } from '@/lib/ai/voice-models'
import { CATEGORIES } from '../categories'

const AWS_BEDROCK_PLATFORM_LINK =
  'https://docs.aws.amazon.com/nova/latest/userguide/speech.html'

const NovaSonic2: LLM = {
  modelId: NOVA_SONIC_MODEL_ID,
  modelName: 'Nova Sonic 2 (AWS)',
  provider: 'aws',
  hostedId: NOVA_SONIC_MODEL_ID,
  platformLink: AWS_BEDROCK_PLATFORM_LINK,
  imageInput: false,
  tools: true,
  tier: 'pro',
  supportsStreaming: true,
  new: true,
  description: () =>
    i18next.t(
      'models.providers.aws.nova_sonic_2.description',
      'Amazon Nova Sonic 2 is a speech-to-speech realtime voice model with native tool use, hosted on AWS Bedrock via SigV4 credentials.'
    ),
  categories: [CATEGORIES.TECHNOLOGY]
}

export const AWS_VOICE_LLM_LIST: LLM[] = [NovaSonic2]
